import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import './BackToHome.css';

const BackToHome = ({ className = '' }) => {
  const classes = ['site-back-link', className].filter(Boolean).join(' ');

  return (
    <Link to="/" className={classes} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
      <ArrowLeft className="ui-icon-lg" aria-hidden />
      <span>Back to pycrust.io</span>
    </Link>
  );
};

export default BackToHome;
